// extracted by mini-css-extract-plugin
export var quantityInput = "_or-0";